import * as React from 'react';

import { FormControlProps } from '../interfaces/FormControlProps';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { ComponentStoreHelpers } from './helpers/ComponentStoreHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { getResourceString } from '../kentico/resource-strings';
import { DropdownMultipleControl } from '../presentational/controls';

export interface DropdownMultipleProps extends FormControlProps {
}

interface IOption {
  value: any;
  label: string;
}

// dropdown has shouldComponentUpdate .. so if properties are added, also change shouldComponentUpdate event
export interface DropdownMultipleState {
  dataSourceCounter?: number;
  value: IOption[];
  isLoading: boolean;   
  isInvalid: boolean;
}    

export class DropdownMultiple extends React.Component<DropdownMultipleProps, DropdownMultipleState> {

    private options: IOption[] = [];

    constructor(props: DropdownMultipleProps) {
      super(props); 
      if (props.formFieldDefinition.datasource) {
        this.state = {
          dataSourceCounter: 0,
          [this.props.formFieldDefinition.datasource] : [],
          value: [],
          isLoading: false,
          isInvalid: false,
        };
      } else {
        this.state = {
          value: [],
          isLoading: false,
          isInvalid: false,
        };
      }
    }

    componentDidMount() {
      this.initDropdowns();
    }

    unmounted: boolean = false;

    componentWillUnmount() {
      this.unmounted = true;
    }

    private initDropdowns = () => {
      if (ComponentStoreHelpers.hasDatasource(this)) {
        this.setState({
          isLoading: true,
        });
        ComponentStoreHelpers.getData(this).then((result) => {
          if (this.unmounted) {
            return;
          }

          if (result) {
            this.options = result;
            this.setFieldValue(this.props.field.value);
          }
        });
      } else {
        const properties = {
          ...FormControlHelpers.inputProperties(this),
        };

        this.setFieldValue(properties.value);
      }
    }

    private setFieldValue(value) {
      
      let selectedValues: IOption[] = value;

      if (!Array.isArray(value)) {
        const values = !!value ? value.split(',') : [];
        const options = ComponentStoreHelpers.getListData(this);
        selectedValues = values.map(val => {
          return options.find(opt => opt.value === val);
        });
        // needed to force initial value in correct format so that if dropdown is not changed by the user
        // that it is correctly shown in the summary
        // see also FormContainer refreshId
        this.props.formikBag.setFieldValue(this.props.formFieldDefinition.name, selectedValues);
      }
      
      this.setState({
        value: [...selectedValues],
        isLoading: false,
      });
    }

    private onSelectionsChange = (selections: IOption[]) => {
      const properties = FormControlHelpers.inputProperties(this);
      properties.onChange({
        target: {
          value: selections,
        },
      });
      this.setState({
        value: [...selections],
      });
    }

    private noSelectionLabel() {
      return getResourceString("Form.Dropdown.ChooseOption");
    }

    private addMoreLabel() {
      return this.props.formFieldDefinition.addMoreLabel || getResourceString('Form.Dropdown.AddMore');
    }

    render() {
      // Get options from Kentico or external dataset
      let options = ComponentStoreHelpers.getListData(this);

      // Add empty first item if required
      if (this.props.formFieldDefinition.includeDefaultEmptyOption) {
        options = [
          {
            value: '',
            label: this.props.formFieldDefinition.defaultEmptyOption,
            text: this.props.formFieldDefinition.defaultEmptyOption,
            parent: '',
            data: {}
          },
          ...options
        ];
      }

      const arrayValue = this.state.value;
      const values: string[] = arrayValue.map(av => typeof (av) === 'string' ? av : av?.value);
      const selectedOptions = values.map(val => {
        return options.find(opt => opt.value === val);
      });

      return (
        <>
          <DropdownMultipleControl
            name={this.props.formFieldDefinition.name}
            label={FormLabelHelpers.getFieldLabel(this)}
            chooseOptionLabel={this.noSelectionLabel()}
            addMoreLabel={this.addMoreLabel()}
            onChange={this.onSelectionsChange}
            options={options}
            selectedValues={selectedOptions.map(v => v?.value || null)}
            error={this.props.form.errors}
            maxItems={this.props.formFieldDefinition.maxItems}
            sortItems={this.props.formFieldDefinition.sortItems}
          />
        </>
      );
    }
}
